export const MAX_BRIEF_SIZE = 5 * 1024 * 1024; // 5MB
export const MAXIMUM_FILES = 5;
export const MAX_STYLES = 3;
export const MAXIMUM_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const BRANDKIT_PICKER_WIDGET = 'BRANDKIT_PICKER';
export const UPLOAD_BRIEF_WIDGET = 'UPLOAD_BRIEF';
export const ASSETS_PICKER_WIDGET = 'ASSETS_PICKER_WIDGET';
export const GENERATE_PROJECT_WIDGET = 'GENERATE_PROJECT_WIDGET';
export const VISUAL_TEMPLATE_STYLES_WIDGET = 'VISUAL_TEMPLATE_STYLES_WIDGET';
export const UPLOAD_IMAGES_WIDGET = 'UPLOAD_IMAGES_WIDGET';
//# sourceMappingURL=consts.js.map